import React from 'react';
import PropTypes from 'prop-types';
import FakeQRCode from '../QRCodeFallbacks/FakeQRCode';


const SingleQRCodeLoader = (props) => {
  const {
    createQRCodeOnly,
    showDynamicComponent
  } = props;

  const CompLoaded = showDynamicComponent &&
    createQRCodeOnly({ 
      componentName: 'RealQRCode', 
    });

  return (
    <div>
      {
        CompLoaded ? (
        <CompLoaded
          {...props}
        />
        ) : (
          <FakeQRCode size={100}/>
        )
        }
    </div>
  );
};

SingleQRCodeLoader.propTypes = {
  siteUrl: PropTypes.string,
  serverUri: PropTypes.string,
};

SingleQRCodeLoader.defaultProps = {
  siteUrl: '',
  serverUri: '',
};

export default SingleQRCodeLoader;
